export default __webpack_public_path__ + "media/images/play-eef76ea0a7a1c01084dc1ad1b077c04b.svg";